import { Instagram, Mail, Phone, ArrowUpRight } from "lucide-react";
import { ORDER_URL, INSTAGRAM_URL, EMAIL, PHONE, PHONE_HREF } from "@/data/menu";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-brand-border bg-brand-bg py-14 md:py-16">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div>
          <p className="font-serif text-xl font-semibold tracking-wide text-brand-dark">
            B<span className="font-sans text-[0.85em]">1</span>{" "}
            <span className="text-brand-accent">&amp;</span> B
            <span className="font-sans text-[0.85em]">2</span>{" "}
            <span className="text-sm font-light tracking-[0.3em] text-brand-gray">
              CATERING
            </span>
          </p>
          <p className="mt-3 max-w-xs text-sm font-light leading-relaxed text-brand-gray">
            Поводът е ваш. Преживяването създаваме заедно.
          </p>
        </div>

        <div className="flex flex-col gap-4">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="inline-flex items-center gap-3 text-sm font-medium text-brand-dark transition-colors hover:text-brand-accent"
          >
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-brand-border">
              <Instagram className="h-4 w-4" aria-hidden="true" />
            </span>
            @b1b2.agency
          </a>
          <a
            href={`mailto:${EMAIL}`}
            data-testid="footer-email-link"
            className="inline-flex items-center gap-3 text-sm font-medium text-brand-dark transition-colors hover:text-brand-accent"
          >
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-brand-border">
              <Mail className="h-4 w-4" aria-hidden="true" />
            </span>
            {EMAIL}
          </a>
          <a
            href={PHONE_HREF}
            data-testid="footer-phone-link"
            className="inline-flex items-center gap-3 text-sm font-medium text-brand-dark transition-colors hover:text-brand-accent"
          >
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-brand-border">
              <Phone className="h-4 w-4" aria-hidden="true" />
            </span>
            {PHONE}
          </a>
          <a
            href={ORDER_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-order-link"
            className="inline-flex items-center gap-3 text-sm font-medium text-brand-dark transition-colors hover:text-brand-accent"
          >
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-brand-border">
              <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
            </span>
            Заявете към „Българче“
          </a>
        </div>
      </div>

      <p className="mt-12 border-t border-brand-border pt-6 text-xs font-light text-brand-gray">
        © {new Date().getFullYear()} B1 &amp; B2 CATERING
      </p>
    </div>
  </footer>
);
